module.exports = __webpack_public_path__ + "static/iphone-bg-d229cea2ca69e07f80d7da553d2cb76a.png";